var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"main-content","tabindex":"-1"}},[_c('h1',[_vm._v("Oops!")]),_vm._m(0),_c('p',[_c('HomeLink',[_vm._v("Go to the home page")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("We could not find anything at this URL. ("),_c('code',[_vm._v("404 Not Found")]),_vm._v(")")])
}]

export { render, staticRenderFns }